
import api from '@/services/Api';
import swal from 'sweetalert2';
import { Options, Vue } from 'vue-class-component';
import Multiselect from '@vueform/multiselect';
import moment from 'moment';
import Q from 'q';


@Options({
  name: 'EditBoUser',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  components: {
    Multiselect,
  },
  computed: {
    userNameTitle() {
      if (this.id && this.id > 0) {
        return this.user.userName;
      }
      if (this.user.userName) {
        return this.user.userName;
      }
      return 'New User';
    },
    passwordIsValid() {
      if (!this.user.password) {
        return false;
      }
      if (this.user.password.length < 8) {
        return false;
      }
      if (!/[a-z]/.test(this.user.password)) {
        return false;
      }
      if (!/[A-Z]/.test(this.user.password)) {
        return false;
      }
      if (!/\d/.test(this.user.password)) {
        return false;
      }
      return true;
    },
  },
})
export default class EditBoUser extends Vue {
  protected readonly id!: number;
  protected readonly passwordIsValid!: boolean;
  public user: SettingUsers = {
    id: 0,
    active: true,
    fullName: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    profileId: null,
    userName: '',
    password: '',
    createdAt: null,
  };
  public passwordFieldType = 'password';
  public profiles: IdName[] = [];
  public wrongProfile = false;
  public wrongEmail = false;
  public wrongMobile = false;
  public firstName = false;
  public wrongUsername = false;
  public lastName = false;
  public usernameExist = false;
  public emailExist = false;
  public saveWas = false;

  getCreateDateFormat(date: string) {
    var stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
  }

  async mounted() {
    swal.showLoading();
    if (this.id && this.id > 0) {
      const apiResult = await api.getBoUserData(this.id);
      if (apiResult.errorMessage) {
        swal.fire({ icon: 'error', title: 'Oops...', text: apiResult.errorMessage });
        return;
      }
      if (apiResult.data) {
        this.user = apiResult.data.user;
      }
    }
    const response = await api.getBoProfiles();
    if (response.errorMessage) {
      swal.fire({ icon: 'error', title: 'Oops...', text: response.errorMessage });
      return;
    }
    if (response.data) {
      this.profiles = response.data;
    }
    swal.close();
  }
  cancel() {
    this.$router.go(-1);
  }
  async save() {
    this.saveWas = true;
    var wasError = false;
    if (!this.user.firstName) {
      this.firstName = true;
      wasError = true;
    }
    if (!this.user.lastName) {
      this.lastName = true;
      wasError = true;
    }
    if (!this.user.userName) {
      this.wrongUsername = true;
      wasError = true;
    }
    if (!this.passwordIsValid) {
      wasError = true;
    }
    if (!this.user.email) {
      this.wrongEmail = true;
      wasError = true;
    }
    if (!this.user.profileId) {
      this.wrongProfile = true;
      wasError = true;
      }
    if (wasError) {
      return;
    }
    swal.showLoading();
    this.wrongProfile = false;
    this.wrongEmail = false;
    this.wrongMobile = false;
    this.wrongUsername = false;
    this.usernameExist = false;
    this.emailExist = false;
    this.firstName = false;
    this.lastName = false;
    if (!this.user.id) {
        this.user.createdAt = moment().format("YYYY-MM-DD[T]HH:mm:ss");
    }
    const apiResult = await api.saveBoUser(this.user);
    await Q.delay(400);
    if (apiResult.errorMessage) {
      swal.fire({ icon: 'error', title: 'Oops...', text: apiResult.errorMessage });
      return;
    }
    if (apiResult.data?.validationErrors && apiResult.data?.validationErrors.length > 0) {
      var errorList: string[] = [];
      apiResult.data?.validationErrors.forEach((element) => {
        switch (element) {
          case 'profile':
            this.wrongProfile = true;
            errorList.push(this.$t('wrong.incorrect-profile'));
            break;
          case 'email':
            this.wrongEmail = true;
            errorList.push(this.$t('wrong.incorrect-email'));
            break;
          case 'mobile':
            this.wrongMobile = true;
            errorList.push(this.$t('wrong.incorrect-mobile'));
            break;
          case 'username':
            this.usernameExist = true;
            errorList.push(this.$t('wrong.incorrect-username'));
            break;
          case 'emailExist':
            this.emailExist = true;
            errorList.push(this.$t('wrong.email-exist'));
            break;
        }
      });
      swal.fire({ icon: 'error', title: 'Oops...', html: errorList.join('<br/>') });
      return;
    }
    swal.fire({
      position: 'center',
      text: this.id > 0 ? this.$t('confirm.user-updated') : this.$t('confirm.user-created'),
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
    });
    this.cancel();
  }
}
